<template>
  <CategoryDetails v-if="goToCategoryDetails" :categoryInformation="categoryInformation" />
  <div v-else>
    <div>
      <div elevation="0" color="transparent" flat>
        <div class="row mb-8">
          <div class="col-6 d-flex justify-content-start">
            <v-card-title>
              {{ $t("Administration.Categories.Categories") }}
            </v-card-title>
          </div>
          <div class="col-6 d-flex justify-content-end">
            <genericBtnComponent :ClickFun="openCreateCategoryModal" svg="2"
              :Title="$t('Administration.Categories.Create')">
            </genericBtnComponent>
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog de suppression -->
    <dialogDelete :title="$t('Administration.Categories.Category')" :yes="confirmDelete" v-model="deleteDialog"
      max-width="600px" />
    <v-table class="table-responsive" style="width: 100%">
      <thead>
        <tr>
          <th class="table_title text-left">{{ $t('Administration.Categories.CategoryName') }}</th>
          <th class="table_title text-left">{{ $t('Administration.Categories.Description') }}</th>
          <th class="table_title text-left">{{ $t('Administration.Categories.Status') }}</th>
          <th class="table_title text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(category) in filteredCategories" :key="category.id" class="Row" @click=" goToCategory(category)">
          <td class="text-left">{{ category.name }}</td>
          <td class="text-left">{{ category.description }}</td>
          <td class="text-left">
            <StatusButton :title="category.status" :color="category.status === 'Inactive' ? '#BDBDBD' : '#3BBAFF'" />
          </td>
          <td class="table_title text-right" width="2%">
            <actions-menu :Id="category.id" :status="category.status" :show-toggle-status="true"
              v-model:dialogDelete="deleteDialog" v-model:dialogEdit="editDialog" @edit="editCategory(category)"
              @update:dialogDelete="deleteCategory(category)" @toggle-status="toggleCategoryStatus(category)" />
          </td>
        </tr>
      </tbody>

    </v-table>



    <v-dialog v-model="createDialog">
      <v-card :width="width" class="pa-4" style="border-radius: 12px">
        <v-card-title class="justify-content-center">
          {{ $t('Administration.Categories.Create') }}
        </v-card-title>
        <v-card-text>
          <v-form ref="categoryForm">
            <!-- Nom de la catégorie -->
            <v-label>{{ $t('Administration.Categories.CategoryName') }} <span class="required-field">*</span></v-label>
            <v-text-field v-model="newCategory.name" outlined required hide-details="auto" />
            <span class="warningHint" id="WarningMsgReference">{{ msg.name }}</span>

            <!-- Description de la catégorie -->
            <v-label>{{ $t('Administration.Categories.Description') }}</v-label>
            <v-text-field v-model="newCategory.description" outlined />

            <!-- Parent de la catégorie -->
            <v-label>{{ $t('Administration.Categories.parent') }}</v-label>
            <v-select :items="categories" item-title="name" item-value="id" v-model="newCategory.parent_category_id"
              outlined />

            <!-- Logo Upload -->
            <div class="row">
              <div class="col justify-content-center" style="max-width: 150px;">
                <v-img v-if="logoUrl" :src="logoUrl" class="nxmlogo" aspect-ratio="1" width="200"></v-img>
                <v-img v-else src="@/assets/upload.png" class="nxmlogo" aspect-ratio="1" width="200"></v-img>
              </div>
              <div class="col justify-content-center">
                <div class="upload" @click="triggerFileInput">
                  <svg class="pr-1 pb-1" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19ZM11.53 13.53C11.38 13.68 11.19 13.75 11 13.75C10.81 13.75 10.62 13.68 10.47 13.53L9.75 12.81V17C9.75 17.41 9.41 17.75 9 17.75C8.59 17.75 8.25 17.41 8.25 17V12.81L7.53 13.53C7.24 13.82 6.76 13.82 6.47 13.53C6.18 13.24 6.18 12.76 6.47 12.47L8.47 10.47C8.54 10.41 8.61 10.36 8.69 10.32C8.71 10.31 8.74 10.3 8.76 10.29C8.82 10.27 8.88 10.26 8.95 10.25C8.98 10.25 9 10.25 9.03 10.25C9.11 10.25 9.19 10.27 9.27 10.3C9.28 10.3 9.28 10.3 9.29 10.3C9.37 10.33 9.45 10.39 9.51 10.45C9.52 10.46 9.53 10.46 9.53 10.47L11.53 12.47C11.82 12.76 11.82 13.24 11.53 13.53Z"
                      fill="#ffffff" />
                    <path
                      d="M17.4297 8.81048C18.3797 8.82048 19.6997 8.82048 20.8297 8.82048C21.3997 8.82048 21.6997 8.15048 21.2997 7.75048C19.8597 6.30048 17.2797 3.69048 15.7997 2.21048C15.3897 1.80048 14.6797 2.08048 14.6797 2.65048V6.14048C14.6797 7.60048 15.9197 8.81048 17.4297 8.81048Z"
                      fill="#ffffff" />
                  </svg>
                  <button type="button" class="load">{{ $t('configuration.logo.uploadLogo') }}</button>
                </div>
                <p v-if="fileName" class="uploaded-file-name mt-2">{{ fileName }}</p>
                <input ref="fileInput" type="file" accept="image/*" @change="onLogoChange" style="display: none;" />
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn class="yes" :disabled="!newCategory.name" @click="saveCategory">
            {{ $t('Administration.Categories.Create_Btn') }}
          </v-btn>
          <v-btn class="Cancel" @click="closeCreateDialog">{{ $t('Administration.Categories.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog d'édition -->
    <v-dialog v-model="editDialog" :width="width">
      <v-card :width="width">
        <v-card-title>{{ $t('Administration.Categories.Edit') }}</v-card-title>
        <v-card-text>
          <v-form ref="editCategoryForm">
            <!-- Category Name -->
            <v-label>{{ $t('Administration.Categories.CategoryName') }} <span class="required-field">*</span></v-label>
            <v-text-field v-model="editCategoryData.name" outlined required hide-details="auto" />

            <!-- Category Description -->
            <v-label>{{ $t('Administration.Categories.Description') }}</v-label>
            <v-text-field v-model="editCategoryData.description" outlined />

            <!-- Parent Category -->
            <v-label>{{ $t('Administration.Categories.parent') }}</v-label>
            <v-select :items="categories" item-title="name" item-value="id"
              v-model="editCategoryData.parent_category_id" outlined />

            <!-- Logo Upload Section -->
            <div class="row">
              <div class="col justify-content-center" style="max-width: 150px;">
                <v-img v-if="logoUrl || editCategoryData.logoUrl" :src="logoUrl || editCategoryData.logoUrl"
                  class="nxmlogo" aspect-ratio="1" width="200"></v-img>
                <v-img v-else src="@/assets/upload.png" class="nxmlogo" aspect-ratio="1" width="200"></v-img>
              </div>
              <div class="col justify-content-center">
                <div class="upload" @click="triggerFileInput">
                  <svg class="pr-1 pb-1" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19ZM11.53 13.53C11.38 13.68 11.19 13.75 11 13.75C10.81 13.75 10.62 13.68 10.47 13.53L9.75 12.81V17C9.75 17.41 9.41 17.75 9 17.75C8.59 17.75 8.25 17.41 8.25 17V12.81L7.53 13.53C7.24 13.82 6.76 13.82 6.47 13.53C6.18 13.24 6.18 12.76 6.47 12.47L8.47 10.47C8.54 10.41 8.61 10.36 8.69 10.32C8.71 10.31 8.74 10.3 8.76 10.29C8.82 10.27 8.88 10.26 8.95 10.25C8.98 10.25 9 10.25 9.03 10.25C9.11 10.25 9.19 10.27 9.27 10.3C9.28 10.3 9.28 10.3 9.29 10.3C9.37 10.33 9.45 10.39 9.51 10.45C9.52 10.46 9.53 10.46 9.53 10.47L11.53 12.47C11.82 12.76 11.82 13.24 11.53 13.53Z"
                      fill="#ffffff" />
                    <path
                      d="M17.4297 8.81048C18.3797 8.82048 19.6997 8.82048 20.8297 8.82048C21.3997 8.82048 21.6997 8.15048 21.2997 7.75048C19.8597 6.30048 17.2797 3.69048 15.7997 2.21048C15.3897 1.80048 14.6797 2.08048 14.6797 2.65048V6.14048C14.6797 7.60048 15.9197 8.81048 17.4297 8.81048Z"
                      fill="#ffffff" />
                  </svg>
                  <button type="button" class="load text-center">{{ $t('configuration.logo.uploadLogo') }}</button>
                </div>
                <p v-if="fileName" class="uploaded-file-name mt-2">{{ fileName }}</p>
                <input ref="fileInput" type="file" accept="image/*" @change="onLogoChange" style="display: none;" />
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn class="yes" :disabled="!editCategoryData.name" @click="saveEditedCategory">
            {{ $t('Administration.Categories.Edit_Btn') }}
          </v-btn>
          <v-btn class="Cancel" @click="closeEditDialog">{{ $t('Administration.Categories.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import actionsMenu from "@/genericComponent/actionsMenu.vue";
import dialogDelete from "@/genericComponent/dialogDelete.vue";
import StatusButton from "@/genericComponent/StatusButton.vue";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue";
import CategoryDetails from "./CategoryDetails.vue";



import { getCategory, UpdateCategoryStatus, AddCategory, deleteCategoryById, updateCategory } from "@/api/index";




export default {
  components: {
    actionsMenu,
    dialogDelete,
    StatusButton,
    genericBtnComponent,
    CategoryDetails

  },
  data() {
    return {
      msg: [],
      categoryInformation: null,
      goToCategoryDetails: false,
      fileName: null,
      CategoryToDeleteId: null,
      width: 800,
      categories: [],
      deleteDialog: false,
      createDialog: false,
      editDialog: false,
      categoryToDelete: null,
      newCategory: { name: '', description: '', parent_category_id: null, LogoImage: null },
      logoUrl: null,  // For previewing the logo

      editCategoryData: {
        id: null,
        name: "",
        description: "",
        status: "",
        LogoImage: null,
      },
      searchTerm: "", // Nouveau champ pour la recherche
    };
  },
  created() {
    this.loadCategories();

    this.emitter.on('event-test', this.handleGlobalSearch);

  },
  beforeUnmount() {
    this.emitter.off('event-test', this.handleGlobalSearch);
  },
  computed: {
    filteredCategories() {
      if (!this.searchTerm) {
        return this.categories;
      }
      const searchTermLower = this.searchTerm.toLowerCase();
      return this.categories.filter(category =>
        category.name.toLowerCase().includes(searchTermLower) ||
        category.description.toLowerCase().includes(searchTermLower)
      );
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleGlobalSearch(searchTerm) {
      this.searchTerm = searchTerm;
    },
    onLogoChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.logoUrl = URL.createObjectURL(file);
        this.newCategory.LogoImage = file;
        this.editCategoryData.LogoImage = file;
        const fileExtension = file.name.split('.').pop();
        const categoryName = this.editCategoryData.name || this.newCategory.name || "Unnamed"; // Nom de la catégorie ou placeholder
        this.fileName = `${categoryName}.${fileExtension}`;
      }
    },
    chooseLogoFiles() {
      let input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";

      input.onchange = (event) => {
        const file = event.target.files[0];
        if (file) {
          this.uploadLogo(file);
        }
      };

      // Déclenche le clic sur l'input invisible
      input.click();
    },

    uploadLogo(file) {
      const reader = new FileReader();

      // Lorsque le fichier est chargé
      reader.onload = (e) => {
        this.logoUrl = e.target.result; // Met à jour l'URL du logo pour afficher l'image
      };

      // Lecture du fichier comme URL de données
      reader.readAsDataURL(file);
    },
    previewLogo(file) {
      // Générer l'URL pour afficher l'image avant sauvegarde
      if (file) {
        this.logoUrl = URL.createObjectURL(file);
      }
    },
    loadCategories() {
      getCategory()
        .then(response => {
          this.categories = response.data.paginatedResult.items.map(category => ({
            id: category.idCategory,
            name: category.name,
            description: category.description,
            status: category.isActive === 1 ? 'Active' : 'Inactive',
            parentCategoryId: category.parentCategoryId,
            logoUrl: category.logoUrl
          }));
        })
        .catch(error => {
          console.error("Erreur lors de la récupération des catégories :", error);
        });
    },
    openCreateCategoryModal() {
      this.fileName = null;
      this.logoUrl = '';
      this.createDialog = true;
      this.newCategory = {
        name: '',
        description: '',
        parent_category_id: null,
        LogoImage: '',
      };
    },
    closeCreateDialog() {
      this.createDialog = false;
    },
    closeEditDialog() {
      this.editDialog = false;
    },
    saveCategory() {
      this.newCategory.parent_category_id =
        this.newCategory.parent_category_id || "";
      AddCategory(this.newCategory)
        .then(() => {
          this.categories.push(this.newCategory);
          this.closeCreateDialog();
        })
        .catch((error) => console.error(error));
    },
    saveEditedCategory() {
      const index = this.categories.findIndex(c => c.id === this.editCategoryData.id);
      if (index !== -1) {
        this.categories.splice(index, 1, { ...this.editCategoryData });
      }
      const category = {
        CategoryId: this.editCategoryData.id,
        name: this.editCategoryData.name,
        description: this.editCategoryData.description,
        parent_category_id: this.editCategoryData.parentCategoryId === null ? "" : this.editCategoryData.parentCategoryId,
        LogoImage: this.editCategoryData.LogoImage ? this.editCategoryData.LogoImage : ""
      }
      updateCategory(category)
        .then(resp => console.log(resp.data))
        .catch(error => console.error(error.msg))
        .finally(() => {
          this.closeEditDialog()
        });
    },
    editCategory(category) {
      this.editCategoryData = JSON.parse(JSON.stringify(category));
      //this.logoUrl = category.logoUrl || null;
      if (category.logoUrl) {
        const fileExtension = category.logoUrl.split('.').pop(); // Extraire l'extension
        const categoryName = category.name || "Unnamed"; // Nom de la catégorie ou placeholder
        this.fileName = `${categoryName}.${fileExtension}`; // Nom final
      } else {
        this.fileName = ""; // Aucun fichier
      }
      this.editDialog = true;
    },
    deleteCategory(category) {
      this.categoryToDelete = category;
      this.deleteDialog = true;
      this.CategoryToDeleteId = category.id;
    },
    confirmDelete() {
      this.categories = this.categories.filter(c => c.id !== this.categoryToDelete.id);
      deleteCategoryById(this.CategoryToDeleteId)
        .then(resp => console.log(resp.data))
        .catch(error => console.error(error.msg))
        .finally(() => {
          this.closeDeleteDialog();
          this.CategoryToDeleteId = null;
        });
    },
    closeDeleteDialog() {
      this.deleteDialog = false;
      this.categoryToDelete = null;
    },
    toggleCategoryStatus(category) {
      category.status = category.status === 'Active' ? 'Inactive' : 'Active';
      const categoryData = {
        categoryId: category.id,
        state: category.status === 'Active' ? 1 : 0,
      }
      UpdateCategoryStatus(categoryData)
        .then(resp => console.log(resp.data))
        .catch(error => console.error(error.msg));
    },
    goToSubCategories(category) {
      this.$router.push({
        name: 'SubCategories',
        params: { categoryId: category.id },
      });
    },
    goToCategory(category) {
      //this.$router.push({ name: 'CategoryDetails', params: { ...category } });
      this.categoryInformation = category;
      this.goToCategoryDetails = true;
    },
  },
};
</script>
<style scoped>
.v-container {
  padding-top: 20px;
}

.v-divider {
  margin-bottom: 20px;
}

.table_title {
  font-weight: bold;
}

.Row:hover {
  background-color: #f2f2f2;
  cursor: pointer;
}

.required-field {
  color: red;
  margin-left: 3px;
  font-weight: bold;
}

.yes {
  background-color: #114ef7;
  font-weight: 600;
  color: #fff;
  margin-left: 300px;
}

.Cancel {
  font-weight: 500;
  color: #768da9;
  border: 1px solid #768da9;
}

.uploadText {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-align: start;
  color: #939EAA;
}

.load {
  font-family: inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 34px;
  color: #fff;
}

.upload {
  background-color: #3bbaff;
  width: 160px;
  height: 35px;
  border-radius: 6px;
  text-align: center;
}

.nxmlogo {
  width: 85px;
  height: 85px;
}

.uploaded-file-name {
  font-size: 14px;
  color: #3bbaff;
  word-break: break-word;
  /* Gérer les noms ou URLs longues */
  margin-top: 8px;
}

.mt-2 {
  margin-top: 8px;
}
</style>
